<template>
  <div v-title :data-title="loginType==4?'分销商 | 登录':'直客 | 登录'">
    <div v-if="loginType==4">
      <div class="pages">
        <div class="logo">
          <img src="../../assets/img/03.jpg" />
        </div>
        <div class="weui-cells weui-cells_form" v-if="logingmode==1">
          <div class="weui-cell weui-cell_vcode">
            <div class="weui-cell__bd">
              <input
                class="weui-input phone"
                type="tel"
                placeholder="请输入手机号"
                v-model="user.UserName"
              />
            </div>
          </div>
          <div class="weui-cell weui-cell_vcode">
            <div class="weui-cell__bd">
              <input class="yzm" type="text" placeholder="验证码" v-model="PicCodeValue" />
            </div>
            <img
              @click="getpiccode()"
              v-bind:src="'data:image/png;base64,'+VerificationCodePic.Base64"
              style="width:25%;margin-right:3%"
            />
          </div>
          <div class="weui-cell weui-cell_vcode">
            <div class="weui-cell__bd">
              <input class="yzm" type="tel" placeholder="请输入验证码" v-model="user.Password" />
              <div class="btn-vercode">
                <button
                  class="weui-btn weui-btn_mini btn-orange"
                  style="width:inherit;"
                  v-if="getcodeshow&&user.UserName.length==11&&PicCodeValue.length>0"
                  @click="getcode()"
                >获取验证码</button>
                <button
                  class="weui-btn weui-btn_mini btn-orange"
                  style="width:inherit"
                  v-if="getcodeshow&&(user.UserName.length!=11||PicCodeValue.length==0)"
                >获取验证码</button>
                <button
                  class="weui-btn weui-btn_mini btn-orange"
                  style="width:inherit;background-color:#ccc"
                  v-if="!getcodeshow"
                >{{waitminutes}}秒</button>
              </div>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <label for="weuiAgree" class="weui-agree"></label>
            </div>
            <div class="weui-cell__ft" @click="toogleMode()">
              <p style="font-size:14px;">账号密码登录</p>
            </div>
          </div>
        </div>

        <div class="weui-cells weui-cells_form" v-if="logingmode==2">
          <div class="weui-cell weui-cell_vcode">
            <div class="weui-cell__bd">
              <input
                class="weui-input phone"
                type="text"
                placeholder="请输入用户名/手机号"
                v-model="user.UserName"
              />
            </div>
          </div>
          <div class="weui-cell weui-cell_vcode">
            <div class="weui-cell__bd">
              <input class="yzm" type="password" placeholder="请输入密码" v-model="user.Password" />
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <label for="weuiAgree" class="weui-agree">
                <input
                  id="weuiAgree"
                  type="checkbox"
                  class="weui-agree__checkbox"
                  v-model="switchValue"
                />
                <span class="weui-agree__text" style="margin-left:10px;">记住密码</span>
              </label>
            </div>
            <span
              class="weui-agree__text"
              @click="forgetpassword()"
              style="margin-left:10px; font-size:14px"
            >忘记密码？</span>
            <div class="weui-cell__ft" @click="toogleMode()">
              <p style="font-size:14px;">手机验证码登录</p>
            </div>
          </div>
        </div>
      </div>
      <div class="weui-btn-area">
        <a class="weui-btn weui-btn_primary btn-login" @click="Login()">登&nbsp;&nbsp;&nbsp;录</a>
      </div>

      <div class="weui-footer">
        <div class="weui-loadmore weui-loadmore_line" style="margin-bottom:0;">
          <span class="weui-loadmore__tips">第三方登录</span>
        </div>
        <div class="other-login">
          <a @click="fxswechatlogin()">
            <img src="../../assets/img/05.png" />
          </a>
        </div>
      </div>
    </div>

    <div v-if="loginType==5">
      <div class="page">
        <div class="logo">
          <img src="../../assets/img/03.jpg" />
        </div>
        <div class="weui-cells weui-cells_form" v-if="logingmode==1">
          <div class="weui-cell weui-cell_vcode">
            <div class="weui-cell__bd">
              <input
                class="weui-input phone"
                type="tel"
                placeholder="请输入手机号"
                v-model="user.UserName"
              />
            </div>
          </div>
          <div class="weui-cell weui-cell_vcode">
            <div class="weui-cell__bd">
              <input class="yzm" type="text" placeholder="验证码" v-model="PicCodeValue" />
            </div>
            <img
              @click="getpiccode()"
              v-bind:src="'data:image/png;base64,'+VerificationCodePic.Base64"
              style="width:25%;margin-right:3%"
            />
          </div>
          <div class="weui-cell weui-cell_vcode">
            <div class="weui-cell__bd">
              <input class="yzm" type="tel" placeholder="请输入验证码" v-model="user.Password" />
              <div class="btn-vercode">
                <button
                  class="weui-btn weui-btn_mini btn-orange"
                  style="width:inherit;"
                  v-if="getcodeshow&&user.UserName.length==11&&PicCodeValue.length>0"
                  @click="getcode(3)"
                >获取验证码</button>
                <button
                  class="weui-btn weui-btn_mini btn-orange"
                  style="width:inherit"
                  v-if="getcodeshow&&(user.UserName.length!=11||PicCodeValue.length==0)"
                >获取验证码</button>
                <button
                  class="weui-btn weui-btn_mini btn-orange"
                  style="width:inherit;background-color:#ccc"
                  v-if="!getcodeshow"
                >{{waitminutes}}秒</button>
              </div>
            </div>
          </div>

          <div class="weui-cell">
            <div class="weui-cell__bd">
              <label for="weuiAgree" class="weui-agree"></label>
            </div>
            <div class="weui-cell__ft" @click="toogleMode()">
              <p style="font-size:14px;">账号密码登录</p>
            </div>
          </div>
        </div>

        <div class="weui-cells weui-cells_form" v-if="logingmode==2">
          <div class="weui-cell weui-cell_vcode">
            <div class="weui-cell__bd">
              <input
                class="weui-input phone"
                type="text"
                placeholder="请输入用户名/手机号"
                v-model="user.UserName"
              />
            </div>
          </div>
          <div class="weui-cell weui-cell_vcode">
            <div class="weui-cell__bd">
              <input class="yzm" type="password" placeholder="请输入密码" v-model="user.Password" />
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <label for="weuiAgree" class="weui-agree">
                <input
                  id="weuiAgree"
                  type="checkbox"
                  class="weui-agree__checkbox"
                  v-model="switchValue"
                />
                <span class="weui-agree__text" style="margin-left:10px;">记住密码</span>
              </label>
            </div>
            <span
              class="weui-agree__text"
              @click="forgetpassword()"
              style="margin-left:10px; font-size:14px"
            >忘记密码？</span>
            <div class="weui-cell__ft" @click="toogleMode()">
              <p style="font-size:14px;">手机验证码登录</p>
            </div>
          </div>
        </div>
      </div>
      <div class="weui-btn-area">
        <a class="weui-btn weui-btn_primary btn-login" @click="Login()">登录/注册</a>
      </div>

      <div class="weui-footer">
        <div class="weui-loadmore weui-loadmore_line" style="margin-bottom:0;">
          <span class="weui-loadmore__tips">第三方登录</span>
        </div>
        <div class="other-login">
          <a @click="wechatlogin()">
            <img src="../../assets/img/05.png" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from "we-vue";
export default {
  name: "login",
  data() {
    return {
      user: { UserName: "", Password: "" },
      switchValue: false,
      loginType: -1,
      logingmode: 1, //1:手机号验证码模式/2:账号密码模式
      getcodeshow: true, //是否显示获取验证码
      waitminutes: "", //可重新获取验证码等待秒数
      codetimer: null, //验证码倒计时
      VerificationCodePic: { OnceString: "" }, //图形验证码信息
      PicCodeValue: "" //图形验证码值
    };
  },
  created: function() {
    var url = window.location.href;
    var type = this.GetRequest(url)["type"];
    if (type == "dis") {
      this.loginType = 4;
    } else {
      this.loginType = 5;
    }
    this.getpiccode();
  },
  methods: {
    setcache: function() {
      var promise = this.$http.get(this.GLOBAL.BASE_URL + "api/getdict");
      promise.then(function(d) {
        var rep = JSON.parse(d.bodyText);
        if (rep.Success) {
          localStorage.setItem("cachedict", JSON.stringify(rep.Data));
          //Vue.prototype.rootglobal.commit('setcachedict', rep.Data);
        } else {
          Toast.fail(rep.Message);
        }
      });
    },

    //切换登录模式
    toogleMode: function() {
      if (this.logingmode == 1) {
        this.logingmode = 2;
        var user = localStorage.getItem("user");
        if (user != "" && user != null) {
          this.user = JSON.parse(user);
          this.switchValue = true;
        }
      } else {
        this.user = { UserName: "", Password: "" };
        this.logingmode = 1;
      }
    },
    //获取图形验证码
    getpiccode: function() {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/getverificationcodepic", {
          params: { codeGuid: this.VerificationCodePic.OnceString }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.VerificationCodePic = rep.Data;
            } else {
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },
    //获取验证码
    getcode: function() {
      if (this.user.UserName == "") {
        Toast.fail("手机号不能为空");
        return;
      }
      if (this.PicCodeValue == "") {
        Toast.fail("图形验证码不能为空");
        return;
      }
      const TIME_COUNT = 60;
      if (!this.codetimer) {
        this.waitminutes = TIME_COUNT;
        this.getcodeshow = false;
        this.codetimer = setInterval(() => {
          if (this.waitminutes > 0 && this.waitminutes <= TIME_COUNT) {
            this.waitminutes--;
          } else {
            this.getcodeshow = true;
            clearInterval(this.codetimer);
            this.codetimer = null;
          }
        }, 1000);
      }
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/getverificationcode", {
          params: {
            picCode: this.PicCodeValue,
            onceString: this.VerificationCodePic.OnceString,
            telephone: this.user.UserName,
            loginType: this.loginType
          }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
            } else {
              this.waitminutes = 0;
              this.getpiccode();
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },

    //验证验证码
    checkcode: function() {
      if (this.user.UserName == "") {
        Toast.fail("手机号不能为空");
        return;
      }
      if (this.user.Password == "") {
        Toast.fail("验证码不能为空");
        return;
      }
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/checkverificationcodeandlogin", {
          params: {
            telephone: this.user.UserName,
            code: this.user.Password,
            loginType: this.loginType
          }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              localStorage.setItem("token", JSON.stringify(rep.Data));
              this.setcache();
              Toast.success("登录成功");
              localStorage.setItem("showFun", false);
              localStorage.setItem("loginType", this.loginType);
              var returnurl = decodeURIComponent(this.$route.query.returnurl);
              if (returnurl != "undefined") {
                this.$router.push(returnurl);
              } else {
                this.$router.push("/app/home");
              }
            } else {
              this.getpiccode();
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },

    forgetpassword: function() {
      this.$router.push("/page/passwordset?logintype=" + this.loginType);
    },

    //登录
    Login: function() {
      debugger
      if (this.logingmode == 2) {
        if (this.user.UserName == "") {
          Toast.fail("用户名不能为空");
          return;
        }
        if (this.user.Password == "") {
          Toast.fail("密码不能为空");
          return;
        }
        if (this.switchValue) {
          localStorage.setItem("user", JSON.stringify(this.user));
        } else {
          localStorage.setItem("user", "");
        }
        this.$store.commit("showLoading");
        this.$http
          .get(this.GLOBAL.BASE_URL + "api/login/user", {
            params: {
              UserName: this.user.UserName,
              Password: this.user.Password,
              LoginType: this.loginType
            }
          })
          .then(
            function(d) {
              var rep = JSON.parse(d.bodyText);
              if (rep.Success) {
                localStorage.setItem("token", JSON.stringify(rep.Data));
                this.setcache();
                Toast.success("登录成功");
                localStorage.setItem("showFun", false);
                localStorage.setItem("loginType", this.loginType);
                var returnurl = decodeURIComponent(this.$route.query.returnurl);
                if (returnurl != "undefined") {
                  this.$router.push(returnurl);
                } else {
                  this.$router.push("/app/home");
                }
              } else {
                Toast.fail(rep.Message);
              }
              this.$store.commit("hideLoading");
            },
            function(d) {
              console.log(d);
            }
          );
      } else if (this.logingmode == 1) {
        this.checkcode();
      }
    },
    //跳转微信授权页
    wechatlogin: function() {
      window.location.href =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
        this.GLOBAL.appid +
        "&redirect_uri=" +
        this.GLOBAL.redirect_uri +
        "%23%2Faccount%2Fwechatbindaccount&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
    },
    fxswechatlogin: function() {
      window.location.href =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
        this.GLOBAL.appid +
        "&redirect_uri=" +
        this.GLOBAL.redirect_uri +
        "%23%2Faccount%2Fwechatbindaccount%3Ftype%3Ddis&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/components/login/login.vue